import React from 'react'
import { makeStyles } from 'tss-react/mui'
import EmsLogo from './EmsLogo'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners'
import RedirectToEmsActivationButton from './RedirectToEmsActivationButton'
import { Banner } from 'src/Components/banner'

const useStyles = makeStyles()(theme => ({
  containerStyle: {
    backgroundColor: theme.palette.primary.light,

    '& > div:first-of-type': {
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
  },
}))

/**
 * This component displays a banner promoting the usage of dynamic EMS.
 */
const EmsPromotionBanner: React.FC = () => {
  const { classes } = useStyles()

  return (
    <Banner
      bannerKey={BannerKey.DynamicEmsBanner}
      icon={<EmsLogo />}
      i18nKey="dynamic-power-prices.ems.promotion-banner.text"
      button={<RedirectToEmsActivationButton />}
      closeType={BannerCloseTypes.permanentOrTemporary}
      containerStyle={classes.containerStyle}
    />
  )
}

export default EmsPromotionBanner
